import type React from "react";

import { useFeatureFlags } from "hooks/useFeatureFlags";

import { CreateLinkInviteModal } from "../CreateLinkInviteModal/CreateLinkInviteModal";
import { CreateEmailInviteModal } from "./components/CreateEmailInviteModal/CreateEmailInviteModal";
import { SelectInviteMethodModal } from "./components/SelectInviteMethodModal/SelectInviteMethodModal";

export const InviteCreationModalGroup: React.FC = () => {
  const { enabledLinkInvitesFlag } = useFeatureFlags();

  // If invite links feature is disable, don't bother rendering modals related to them
  if (!enabledLinkInvitesFlag) {
    return <CreateEmailInviteModal />;
  }

  return (
    <>
      <SelectInviteMethodModal />
      <CreateLinkInviteModal />
      <CreateEmailInviteModal />
    </>
  );
};
